"use client";

import { useState } from "react";
import { ExternalLink, Globe } from "lucide-react";

import { t } from "@/lib/localization";
import { PreviewButton } from "../shared/PreviewButton";
import { useLomdaLocale } from "../../../hooks/useLomdaLocale";
import { ICON_SIZE } from "../../../lib/iconSizes";

/** Shown instead of the iframe when the site refuses to be framed. */
export function BlockedEmbedCard({ href }: { href: string }) {
    const locale = useLomdaLocale();
    const { hostname } = new URL(href);

    return (
        <div className="lomda-v3-card-surface flex aspect-video w-full flex-col items-center justify-center gap-4 rounded-xl border p-6 text-center">
            <SiteIcon key={hostname} hostname={hostname} />
            <div className="flex max-w-md flex-col gap-1">
                <span dir="ltr" className="lomda-v3-text-h6 break-all">
                    {hostname.replace(/^www\./, "")}
                </span>
                <p className="lomda-v3-text-p">
                    {t("lomda-v3-editor.embed.blocked.text", locale)}
                </p>
            </div>
            <PreviewButton asChild className="gap-2">
                <a href={href} target="_blank" rel="noopener noreferrer">
                    <ExternalLink
                        className={`${ICON_SIZE.embedOpenIcon} shrink-0`}
                    />
                    {t("lomda-v3-editor.embed.blocked.open", locale)}
                </a>
            </PreviewButton>
        </div>
    );
}

function SiteIcon({ hostname }: { hostname: string }) {
    const [failed, setFailed] = useState(false);

    return (
        <span className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-[hsl(var(--lomda-muted))]">
            {failed ? (
                <Globe className={ICON_SIZE.embedSiteIcon} />
            ) : (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                    src={`https://${hostname}/favicon.ico`}
                    alt=""
                    referrerPolicy="no-referrer"
                    onError={() => setFailed(true)}
                    className={`${ICON_SIZE.embedSiteIcon} object-contain`}
                />
            )}
        </span>
    );
}
